<template>
	<LabeledFieldLayout
		:class="classes"
		:is-valid="isValid"
	>
		<TeamingDropDown
			:class-name="dropDownClass"
			:disabled="disabled"
			:options="options"
			:value="value"
			:is-valid="isValid"
			@change="onChange"
			v-on="bubble(
				`opening`,
				`opened`,
				`closing`,
				`closed`
			)"
		>
			<template #options="{ option, onOptionClicked, }">
				<slot name="options" :option="option" :onOptionClicked="onOptionClicked">
					<div @click="onOptionClicked( option, $event )">{{ option.text }}</div>
				</slot>
			</template>
		</TeamingDropDown>
	</LabeledFieldLayout>
</template>

<script>
import EventsMixin from "../../mixins/EventsMixin";
import LabeledFieldLayout from "./LabeledFieldLayout";
import TeamingDropDown from "../TeamingDropDown";

export default {
	name: "LabeledDropDown",
	mixins: [ EventsMixin, ],
	emits: [
		"change",
		"opening",
		"opened",
		"closing",
		"closed",
	],
	components: {
		LabeledFieldLayout,
		TeamingDropDown,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		dropDownClass: {
			type: String,
			default: "",
		},
		/** [ { text:String, value:String }, ... ] */
		options: {
			type: Array,
			required: true,
		},
		value: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		isValid: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		classes() {
			return `labeled-drop-down ${ this.className }`.trim();
		},
	},
	methods: {
		onChange( option ) {
			this.$emit( "change", option );
		},
	},
};
</script>

<style lang="scss" scoped>
.labeled-drop-down {
	.teaming-drop-down {
		width: 100%;
	}
}
</style>
